<!--
 * @message: 时间日期组件
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-22 10:54:30
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_DateTimePicker.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-08-22 17:03:30
-->
<template >
  <v-menu
    ref="menu"
    v-model="showMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    eager
    open-on-focus
    :return-value.sync="datetime"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-sheet
        class="text--secondary"
        v-if="label"
        :class="isRequire ? 'mrc_text_require' : ''"
        >{{ label }}</v-sheet
      >
      <v-text-field
        :value="datetime.replace(/\-/g, '/').replace(' / ', ' - ')"
        readonly
        ref="input"
        v-bind="attrs"
        v-on="filled ? on : null"
        :rules="rules"
        :disabled="disabled"
        :hide-details="hideDetail"
        :placeholder="placeholder"
        :filled="filled"
        :clearable="filled"
        @click:clear="onClear"
        single-line
        @input="datetime = ''"
        dense
        @focus="filled ? on : null"
        @click:append="$refs.input.click()"
      >
        <template #append>
          <span
            class="material-icons-round text--secondary"
            @click="
              (e) => {
                showMenu = false;
                e.preventDefault();
                e.stopPropagation();
                $refs.input.onFocus();
              }
            "
            >{{ filled ? "calendar_today" : "" }}</span
          >
        </template>
      </v-text-field>
    </template>
    <v-card v-if="type == 'date'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-date-picker
          :day-format="
            (date) => {
              return $getDateTime(date, 'D');
            }
          "
          :locale="defaultLang"
          v-model="datetime"
          :allowed-dates="(val) => refuseDate.indexOf(val) === -1"
          no-title
          :show-current="false"
          scrollable
          :min="min"
          :max="max"
          color="primary"
          flat
        >
          <v-spacer></v-spacer>
          <!-- <v-btn
            text
            color="primary"
            height="34"
            class="text-capitalize mx-6  mb-4"
            @click="showMenu = false"
            small
            rounded
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5  mb-4 mr-4"
            rounded
            height="34"
            small
            @click="$refs.menu.save(datetime)"
            >OK</v-btn
          > -->
        </v-date-picker>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'month'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-date-picker
          :day-format="
            (date) => {
              return $getDateTime(date, 'D');
            }
          "
          v-model="datetime"
          no-title
          scrollable
          :locale="defaultLang"
          type="month"
          color="primary"
          :show-current="false"
          flat
        >
          <!-- <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize mx-6"
            @click="showMenu = false"
            small
            rounded
            >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            small
            @click="$refs.menu.save(datetime)"
            >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
          > -->
        </v-date-picker>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'year'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-date-picker
          :day-format="
            (date) => {
              return $getDateTime(date, 'D');
            }
          "
          v-model="datetime"
          no-title
          scrollable
          :locale="defaultLang"
          type="year"
          color="primary"
          :show-current="false"
          flat
        >
        </v-date-picker>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'time'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet class="d-flex flex-row justify-space-arounnd pa-0">
          <TimeWidget
            @change="
              (time) => {
                datetime = time;
              }
            "
            :defaultTime="0"
          />
        </v-sheet>
        <!-- <v-sheet class="d-flex pa-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize mx-6"
            @click="onCancel"
            small
            rounded
            >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            small
            @click="$refs.menu.save(datetime)"
            >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
          >
        </v-sheet> -->
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'datetime'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet class="d-flex flex-row justify-space-arounnd pa-0">
          <Taber
            :curTab="curTab"
            @change="(tab) => (curTab = tab)"
            :items="taber"
            backgroundColor="white"
            :grow="false"
            special
            :centered="false"
          >
            <template v-slot:content-1>
              <v-date-picker
                :day-format="
                  (date) => {
                    return $getDateTime(date, 'D');
                  }
                "
                :locale="defaultLang"
                v-model="DateTime.Date"
                no-title
                scrollable
                :show-current="false"
                color="primary"
                :max="getMaxMin('maxdate')"
                :min="getMaxMin('mindate')"
                flat
              ></v-date-picker>
            </template>
            <template v-slot:content-2>
              <TimeWidget
                @change="
                  (time) => {
                    DateTime.Time = time;
                  }
                "
                :max="getMaxMin('maxtime')"
                :min="getMaxMin('mintime')"
              />
            </template>
          </Taber>
        </v-sheet>
        <v-sheet class="d-flex px-3 pb-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize mx-6"
            @click="onCancel"
            small
            rounded
            >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            :disabled="!canConfirm || !DateTime.Date || !DateTime.Time"
            small
            @click="$refs.menu.save(DateTime.Date + ' ' + DateTime.Time)"
            >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
          >
        </v-sheet>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'day30min'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet class="d-flex flex-row justify-space-arounnd pa-0">
          <Taber
            :curTab="curTab"
            @change="(tab) => (curTab = tab)"
            :items="taber"
            backgroundColor="white"
            special
            contentBackground="pa-0"
            :grow="false"
            :centered="false"
          >
            <template v-slot:content-1>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-3"
                height="330"
              >
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey mx-2 lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      day30Minute.StartDate
                        ? day30Minute.StartDate.replace(/\-/g, "/")
                        : $t("label_essweb_system_dateFormat_fromLabel")
                    }}</v-sheet
                  >
                  <v-date-picker
                    :day-format="
                      (date) => {
                        return $getDateTime(date, 'D');
                      }
                    "
                    :locale="defaultLang"
                    v-model="day30Minute.StartDate"
                    no-title
                    :show-current="false"
                    scrollable
                    color="primary"
                    flat
                  ></v-date-picker>
                </v-sheet>
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="
                      border-color: var(--main-border-color);
                      margin-left: 7.5px;
                    "
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      day30Minute.EndDate
                        ? day30Minute.EndDate.replace(/\-/g, "/")
                        : $t("label_essweb_system_dateFormat_toLabel")
                    }}
                  </v-sheet>
                  <v-date-picker
                    :day-format="
                      (date) => {
                        return $getDateTime(date, 'D');
                      }
                    "
                    :locale="defaultLang"
                    v-model="day30Minute.EndDate"
                    no-title
                    :show-current="false"
                    scrollable
                    color="primary"
                    flat
                    :min="day30Minute.StartDate"
                  ></v-date-picker>
                </v-sheet>
              </v-sheet>
            </template>
            <template v-slot:content-2>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-3"
                height="350"
              >
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey mx-2 lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      day30Minute.StartDate
                        ? day30Minute.StartDate.replace(/\-/g, "/") +
                          " " +
                          day30Minute.StartTime
                        : $t("label_essweb_system_dateFormat_fromLabel")
                    }}</v-sheet
                  >
                  <!-- 2021-11-09 不受限30---60 -->
                  <TimeWidgetSE
                    :startTime="startMinTime"
                    :endTime="endMaxTime"
                    :timeType="60"
                    :defaultHour="day30Minute.defaultHour"
                    :defaultMin="day30Minute.defaultMin"
                    @change="
                      (time, minute) => {
                        day30Minute.StartTime = time;
                        day30Minute.StartTimeMinute = minute;
                      }
                    "
                    :max="
                      day30Minute.StartDate == day30Minute.EndDate
                        ? day30Minute.EndTimeMinute
                        : ''
                    "
                  />
                </v-sheet>
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="
                      border-color: var(--main-border-color);
                      margin-left: 7.5px;
                    "
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey mx-2 lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      day30Minute.StartDate
                        ? day30Minute.StartDate.replace(/\-/g, "/") +
                          " " +
                          day30Minute.EndTime
                        : $t("label_essweb_system_dateFormat_toLabel")
                    }}</v-sheet
                  >
                  <!-- 2021-11-09 不受限30---60 -->
                  <TimeWidgetSE
                    :startTime="day30Minute.startMinTime_forEnd"
                    :endTime="day30Minute.endMaxTime_forEnd"
                    :timeType="60"
                    isEnd
                    :defaultHour="day30Minute.defaultHour_forEnd"
                    :defaultMin="day30Minute.defaultMin_forEnd"
                    :ctrlTime="day30Minute.StartTimeMinute"
                    @change="
                      (time, minute) => {
                        day30Minute.EndTime = time;
                        day30Minute.EndTimeMinute = minute;
                      }
                    "
                    :min="
                      day30Minute.StartDate == day30Minute.EndDate
                        ? day30Minute.StartTimeMinute
                        : ''
                    "
                  />
                </v-sheet>
              </v-sheet>
            </template>
          </Taber>
        </v-sheet>
        <v-sheet class="d-flex px-3 pb-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize mx-6"
            @click="onCancel"
            small
            rounded
            >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            :disabled="
              !canConfirm ||
              !day30Minute.StartDate ||
              !day30Minute.EndDate ||
              (day30Minute.EndDate == day30Minute.StartDate &&
                day30Minute.StartTime == day30Minute.EndTime)
            "
            small
            @click="
              $refs.menu.save(
                day30Minute.StartDate +
                  ' ' +
                  day30Minute.StartTime +
                  ' - ' +
                  day30Minute.EndDate +
                  ' ' +
                  day30Minute.EndTime
              )
            "
            >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
          >
        </v-sheet>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'day15min'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet class="d-flex flex-row justify-space-arounnd pa-0">
          <Taber
            :curTab="curTab"
            @change="(tab) => (curTab = tab)"
            :items="taber"
            special
            contentBackground="pa-0"
            backgroundColor="white"
            :grow="false"
            :centered="false"
          >
            <template v-slot:content-1>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-3"
                height="330"
              >
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey mx-2 lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      day15Minute.StartDate
                        ? day15Minute.StartDate.replace(/\-/g, "/")
                        : $t("label_essweb_system_dateFormat_fromLabel")
                    }}
                  </v-sheet>
                  <v-date-picker
                    :day-format="
                      (date) => {
                        return $getDateTime(date, 'D');
                      }
                    "
                    :locale="defaultLang"
                    v-model="day15Minute.StartDate"
                    no-title
                    :show-current="false"
                    scrollable
                    color="primary"
                    flat
                  ></v-date-picker>
                </v-sheet>
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="
                      border-color: var(--main-border-color);
                      margin-left: 7.5px;
                    "
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      day15Minute.EndDate
                        ? day15Minute.EndDate.replace(/\-/g, "/")
                        : $t("label_essweb_system_dateFormat_toLabel")
                    }}
                  </v-sheet>
                  <v-date-picker
                    :day-format="
                      (date) => {
                        return $getDateTime(date, 'D');
                      }
                    "
                    :locale="defaultLang"
                    v-model="day15Minute.EndDate"
                    no-title
                    :show-current="false"
                    scrollable
                    color="primary"
                    flat
                    :min="day15Minute.StartDate"
                  ></v-date-picker>
                </v-sheet>
              </v-sheet>
            </template>
            <template v-slot:content-2>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-3"
                height="350"
              >
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey  mx-2 lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      day15Minute.StartDate
                        ? day15Minute.StartDate.replace(/\-/g, "/") +
                          " " +
                          day15Minute.StartTime
                        : $t("label_essweb_system_dateFormat_fromLabel")
                    }}</v-sheet
                  >
                  <!-- 2021-11-09 受限制15---TimeType -->
                  <TimeWidgetSE
                    :startTime="startMinTime"
                    :endTime="endMaxTime"
                    isLimit
                    :timeType="TimeType"
                    :defaultHour="day15Minute.defaultHour"
                    :defaultMin="day15Minute.defaultMin"
                    @change="
                      (time, minute) => {
                        day15Minute.StartTime = time;
                        day15Minute.StartTimeMinute = minute;
                      }
                    "
                    :max="
                      day15Minute.StartDate == day15Minute.EndDate
                        ? day15Minute.EndTimeMinute
                        : ''
                    "
                  />
                </v-sheet>
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="
                      border-color: var(--main-border-color);
                      margin-left: 7.5px;
                    "
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey mx-2 lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      day15Minute.EndDate
                        ? day15Minute.EndDate + " " + day15Minute.EndTime
                        : $t("label_essweb_system_dateFormat_toLabel")
                    }}</v-sheet
                  >
                  <!-- 2021-11-09 受限制15---TimeType -->
                  <TimeWidgetSE
                    isEnd
                    isLimit
                    :startTime="day15Minute.startMinTime_forEnd"
                    :endTime="day15Minute.endMaxTime_forEnd"
                    :defaultHour="day15Minute.defaultHour_forEnd"
                    :defaultMin="day15Minute.defaultMin_forEnd"
                    :timeType="TimeType"
                    :ctrlTime="day15Minute.StartTimeMinute"
                    @change="
                      (time, minute) => {
                        day15Minute.EndTime = time;
                        day15Minute.EndTimeMinute = minute;
                      }
                    "
                    :min="
                      day15Minute.StartDate == day15Minute.EndDate
                        ? day15Minute.StartTimeMinute
                        : ''
                    "
                  />
                </v-sheet>
              </v-sheet>
            </template>
          </Taber>
        </v-sheet>
        <v-sheet class="d-flex px-3 pb-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize mx-6"
            @click="onCancel"
            small
            rounded
            >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
          >

          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            :disabled="
              !canConfirm ||
              !day15Minute.StartDate ||
              !day15Minute.EndDate ||
              (day15Minute.EndDate == day15Minute.StartDate &&
                day15Minute.StartTime == day15Minute.EndTime)
            "
            small
            @click="
              $refs.menu.save(
                day15Minute.StartDate +
                  ' ' +
                  day15Minute.StartTime +
                  ' - ' +
                  day15Minute.EndDate +
                  ' ' +
                  day15Minute.EndTime
              )
            "
            >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
          >
        </v-sheet>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'daytime'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet class="d-flex flex-row justify-space-arounnd pa-0">
          <Taber
            :curTab="curTab"
            @change="(tab) => (curTab = tab)"
            :items="taber"
            backgroundColor="white"
            :grow="false"
            special
            contentBackground="pa-0"
            :centered="false"
          >
            <template v-slot:content-1>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-3"
                height="330"
              >
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey mx-2 lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      dayTime.StartDate
                        ? dayTime.StartDate.replace(/\-/g, "/")
                        : $t("label_essweb_system_dateFormat_fromLabel")
                    }}
                  </v-sheet>
                  <v-date-picker
                    :day-format="
                      (date) => {
                        return $getDateTime(date, 'D');
                      }
                    "
                    :locale="defaultLang"
                    v-model="dayTime.StartDate"
                    no-title
                    :show-current="false"
                    scrollable
                    color="primary"
                    flat
                  ></v-date-picker>
                </v-sheet>
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="
                      border-color: var(--main-border-color);
                      margin-left: 7.5px;
                    "
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      dayTime.EndDate
                        ? dayTime.EndDate.replace(/\-/g, "/")
                        : $t("label_essweb_system_dateFormat_toLabel")
                    }}
                  </v-sheet>
                  <v-date-picker
                    :day-format="
                      (date) => {
                        return $getDateTime(date, 'D');
                      }
                    "
                    :locale="defaultLang"
                    v-model="dayTime.EndDate"
                    no-title
                    :show-current="false"
                    scrollable
                    color="primary"
                    flat
                    :min="dayTime.StartDate"
                  ></v-date-picker>
                </v-sheet>
              </v-sheet>
            </template>
            <template v-slot:content-2>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-3"
                height="360"
              >
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey mx-2 lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      dayTime.StartDate
                        ? dayTime.StartDate.replace(/\-/g, "/") +
                          " " +
                          dayTime.StartTime
                        : $t("label_essweb_system_dateFormat_fromLabel")
                    }}</v-sheet
                  >
                  <TimeWidgetSE
                    :startTime="startMinTime"
                    :endTime="endMaxTime"
                    :timeType="60"
                    :defaultHour="dayTime.defaultHour"
                    :changeTime="dayTime.StartTimeMinute"
                    :defaultMin="dayTime.defaultMin"
                    @change="
                      (time, minute) => {
                        dayTime.StartTime = time;
                        dayTime.StartTimeMinute = minute;
                      }
                    "
                    :max="
                      dayTime.StartDate == dayTime.EndDate
                        ? dayTime.EndTimeMinute
                        : ''
                    "
                  />
                </v-sheet>
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="
                      border-color: var(--main-border-color);
                      margin-left: 7.5px;
                    "
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey mx-2 lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      dayTime.EndDate
                        ? dayTime.EndDate.replace(/\-/g, "/") +
                          " " +
                          dayTime.EndTime
                        : $t("label_essweb_system_dateFormat_toLabel")
                    }}</v-sheet
                  >
                  <!-- onlyShowHour -->
                  <TimeWidgetSE
                    isEnd
                    :startTime="dayTime.startMinTime_forEnd"
                    :endTime="dayTime.endMaxTime_forEnd"
                    :timeType="60"
                    :changeTime="dayTime.EndTimeMinute"
                    :defaultHour="dayTime.defaultHour_forEnd"
                    :defaultMin="dayTime.defaultMin_forEnd"
                    @change="
                      (time, minute) => {
                        dayTime.EndTime = time;
                        dayTime.EndTimeMinute = minute;
                      }
                    "
                    :min="
                      dayTime.StartDate == dayTime.EndDate
                        ? dayTime.StartTimeMinute
                        : ''
                    "
                  />
                </v-sheet>
              </v-sheet>
            </template>
          </Taber>
        </v-sheet>
        <v-sheet class="d-flex px-3 pb-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize mx-6"
            @click="onCancel"
            small
            rounded
            >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            :disabled="
              !canConfirm ||
              !dayTime.StartDate ||
              !dayTime.EndDate ||
              (dayTime.EndDate == dayTime.StartDate &&
                dayTime.StartTime == dayTime.EndTime)
            "
            small
            @click="
              $refs.menu.save(
                dayTime.StartDate +
                  ' ' +
                  dayTime.StartTime +
                  ' - ' +
                  dayTime.EndDate +
                  ' ' +
                  dayTime.EndTime
              )
            "
            >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
          >
        </v-sheet>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'daterange'" class="pa-0 ma-0">
      <v-card-text class="pa-0 pb-3 ma-0">
        <v-sheet
          class="d-flex flex-row justify-space-arounnd pa-3"
          height="330"
        >
          <v-sheet class="fill-height">
            <v-sheet
              height="30"
              color="grey lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
              >{{
                SEDate.StartDate
                  ? SEDate.StartDate.replace(/\-/g, "/")
                  : $t("label_essweb_system_dateFormat_fromLabel")
              }}</v-sheet
            >
            <v-date-picker
              :day-format="
                (date) => {
                  return $getDateTime(date, 'D');
                }
              "
              :locale="defaultLang"
              v-model="SEDate.StartDate"
              no-title
              :show-current="false"
              scrollable
              color="primary"
              flat
              :min="isAllowDate ? defaultMin : null"
              :max="SEDate.EndDate"
            ></v-date-picker>
          </v-sheet>
          <div
            class="fill-height d-flex align-center text-center flex-grow-1"
            style="width: 15px"
          >
            <v-divider
              vertical
              style="border-color: var(--main-border-color); margin-left: 7.5px"
            ></v-divider>
            <v-sheet class="border_style"></v-sheet>
          </div>
          <v-sheet class="fill-height">
            <v-sheet
              height="30"
              color="grey lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
              >{{
                SEDate.EndDate
                  ? SEDate.EndDate.replace(/\-/g, "/")
                  : $t("label_essweb_system_dateFormat_toLabel")
              }}</v-sheet
            >
            <v-date-picker
              :day-format="
                (date) => {
                  return $getDateTime(date, 'D');
                }
              "
              :locale="defaultLang"
              v-model="SEDate.EndDate"
              no-title
              :show-current="false"
              scrollable
              color="primary"
              flat
              :max="isAllowDate ? defaultMax : null"
              :min="SEDate.StartDate"
            ></v-date-picker>
          </v-sheet>
        </v-sheet>
        <v-sheet class="d-flex px-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize mx-6"
            @click="onCancel"
            small
            rounded
            >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            :disabled="!SEDate.StartDate || !SEDate.EndDate"
            small
            @click="$refs.menu.save(SEDate.StartDate + ' - ' + SEDate.EndDate)"
            >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
          >
        </v-sheet>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'timerange'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet
          class="d-flex flex-row justify-space-arounnd pa-3"
          height="320"
        >
          <TimeWidget
            @change="
              (time, minute) => {
                TimeRange.StartTime = time;
                TimeRange.StartTimeMinute = minute;
              }
            "
            :max="TimeRange.EndTimeMinute"
          />
          <div
            class="fill-height d-flex align-center text-center flex-grow-1"
            style="width: 15px"
          >
            <v-divider
              vertical
              style="border-color: var(--main-border-color); margin-left: 7.5px"
            ></v-divider>
            <v-sheet class="border_style"></v-sheet>
          </div>
          <TimeWidget
            showDay
            isEnd
            @change="
              (time, minute) => {
                TimeRange.EndTime = time;
                TimeRange.EndTimeMinute = minute;
              }
            "
            :min="TimeRange.StartTimeMinute"
          />
        </v-sheet>
        <v-sheet class="d-flex pa-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize mx-6"
            @click="onCancel"
            small
            rounded
            >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            :disabled="!TimeRange.StartTime || !TimeRange.EndTime"
            small
            @click="
              $refs.menu.save(TimeRange.StartTime + ' - ' + TimeRange.EndTime)
            "
            >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
          >
        </v-sheet>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'dateapm'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet
          class="d-flex flex-row justify-space-arounnd pa-3"
          height="400"
        >
          <Taber
            :curTab="curTab"
            :items="taber"
            @change="(tab) => (curTab = tab)"
            backgroundColor="white"
            :grow="false"
            special
            contentBackground="pa-0"
            :centered="false"
          >
            <template v-slot:content-1>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-0"
                height="330"
              >
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      DateAPM.StartDate
                        ? DateAPM.StartDate.replace(/\-/g, "/") +
                          " " +
                          DateAPM.start
                        : $t("label_essweb_system_dateFormat_fromLabel")
                    }}</v-sheet
                  >
                  <v-date-picker
                    :day-format="
                      (date) => {
                        return $getDateTime(date, 'D');
                      }
                    "
                    :locale="defaultLang"
                    v-model="DateAPM.StartDate"
                    no-title
                    :show-current="false"
                    scrollable
                    color="primary"
                    flat
                    :max="DateAPM.EndDate"
                  ></v-date-picker>
                </v-sheet>
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="
                      border-color: var(--main-border-color);
                      margin-left: 7.5px;
                    "
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>
                <v-sheet class="fill-height">
                  <v-sheet
                    height="30"
                    color="grey lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                    >{{
                      DateAPM.EndDate
                        ? DateAPM.EndDate.replace(/\-/g, "/") +
                          " " +
                          DateAPM.end
                        : $t("label_essweb_system_dateFormat_toLabel")
                    }}</v-sheet
                  >
                  <v-date-picker
                    :day-format="
                      (date) => {
                        return $getDateTime(date, 'D');
                      }
                    "
                    :locale="defaultLang"
                    v-model="DateAPM.EndDate"
                    no-title
                    :show-current="false"
                    scrollable
                    color="primary"
                    flat
                    :min="DateAPM.StartDate"
                  ></v-date-picker>
                </v-sheet>
              </v-sheet>
            </template>
            <template v-slot:content-2>
              <v-sheet class="d-flex flex-row justify-space-arounnd">
                <v-sheet
                  height="30"
                  width="100%"
                  color="grey  mx-2 lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                  >{{
                    DateAPM.StartDate
                      ? DateAPM.StartDate.replace(/\-/g, "/") +
                        " " +
                        DateAPM.start
                      : $t("label_essweb_system_dateFormat_fromLabel")
                  }}</v-sheet
                >
                <v-sheet
                  width="100%"
                  height="30"
                  color="grey  mx-2 lighten-3 rounded text--secondary  text-center text-subtitle-2 d-flex justify-center align-center"
                  >{{
                    DateAPM.EndDate
                      ? DateAPM.EndDate.replace(/\-/g, "/") + " " + DateAPM.end
                      : $t("label_essweb_system_dateFormat_toLabel")
                  }}</v-sheet
                >
              </v-sheet>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-3"
                height="300"
              >
                <v-sheet
                  color="white"
                  class="
                    pa-1
                    d-flex
                    flex-column flex-grow-1
                    align-center
                    justify-center
                  "
                  height="100%"
                  width="290"
                >
                  <v-btn
                    :text="DateAPM.StartTimeMinute == 12 * 60 ? false : true"
                    class="text-center mt-1 pa-1 text-block"
                    depressed
                    :disabled="!DateAPM.EndDate || !DateAPM.StartDate"
                    @click="
                      DateAPM.start = 'AM';
                      DateAPM.StartTime = '00:00';
                      DateAPM.StartTimeMinute = 12 * 60;
                    "
                    :color="
                      DateAPM.StartTimeMinute == 12 * 60
                        ? 'primary lighten-3 text--primary'
                        : 'text--primary'
                    "
                    >AM</v-btn
                  >

                  <v-btn
                    :text="DateAPM.StartTimeMinute == 24 * 60 ? false : true"
                    class="text-center mt-1 pa-1 text-block"
                    depressed
                    :disabled="!DateAPM.EndDate || !DateAPM.StartDate"
                    @click="
                      DateAPM.start = 'PM';
                      DateAPM.StartTime = '24:00';
                      DateAPM.StartTimeMinute = 24 * 60;
                    "
                    :color="
                      DateAPM.StartTimeMinute == 24 * 60
                        ? 'primary lighten-3 text--primary'
                        : 'text--primary'
                    "
                    >PM</v-btn
                  >
                </v-sheet>
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="
                      border-color: var(--main-border-color);
                      margin-left: 8.5px;
                    "
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>

                <v-sheet
                  color="white"
                  class="
                    pa-1
                    d-flex
                    flex-column flex-grow-1
                    align-center
                    justify-center
                  "
                  height="100%"
                  width="290"
                >
                  <v-btn
                    :text="DateAPM.EndTimeMinute == 12 * 60 ? false : true"
                    class="text-center mt-1 pa-1 text-block"
                    :disabled="
                      !DateAPM.EndDate ||
                      !DateAPM.StartDate ||
                      (DateAPM.StartDate === DateAPM.EndDate &&
                        DateAPM.StartTimeMinute == 24 * 60)
                    "
                    @click="
                      DateAPM.end = 'AM';
                      DateAPM.EndTime = '12:00';
                      DateAPM.EndTimeMinute = 12 * 60;
                    "
                    depressed
                    :color="
                      DateAPM.EndTimeMinute == 12 * 60
                        ? 'primary lighten-3 text--primary'
                        : 'text--primary'
                    "
                    >AM</v-btn
                  >

                  <v-btn
                    :text="DateAPM.EndTimeMinute == 24 * 60 ? false : true"
                    class="text-center mt-1 pa-1 text-block"
                    depressed
                    :disabled="!DateAPM.EndDate || !DateAPM.StartDate"
                    @click="
                      DateAPM.end = 'PM';
                      DateAPM.EndTime = '24:00';
                      DateAPM.EndTimeMinute = 24 * 60;
                    "
                    :color="
                      DateAPM.EndTimeMinute == 24 * 60
                        ? 'primary lighten-3 text--primary'
                        : 'text--primary'
                    "
                    >PM</v-btn
                  ></v-sheet
                >
              </v-sheet>
            </template>
          </Taber></v-sheet
        >
        <v-sheet class="d-flex pa-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize mx-6"
            @click="onCancel"
            small
            rounded
            >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            :disabled="
              !canConfirm ||
              !DateAPM.StartDate ||
              !DateAPM.EndDate ||
              !DateAPM.StartTime ||
              !DateAPM.EndTime
            "
            small
            @click="
              $refs.menu.save(
                DateAPM.StartDate +
                  ' ' +
                  DateAPM.start +
                  ' - ' +
                  DateAPM.EndDate +
                  ' ' +
                  DateAPM.end
              )
            "
            >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
          >
        </v-sheet>
      </v-card-text></v-card
    >
    <v-card v-if="type == 'onedatetimerange'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet
          class="d-flex flex-row justify-space-arounnd pa-3"
          height="400"
        >
          <Taber
            :curTab="curTab"
            :items="taber"
            @change="(tab) => (curTab = tab)"
            backgroundColor="white"
            :grow="false"
            special
            contentBackground="pa-0"
            :centered="false"
          >
            <template v-slot:content-1>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-0"
                height="260"
              >
                <v-date-picker
                  :day-format="
                    (date) => {
                      return $getDateTime(date, 'D');
                    }
                  "
                  :locale="defaultLang"
                  v-model="OneSeDateTime.Date"
                  no-title
                  :show-current="false"
                  scrollable
                  color="primary"
                  flat
                ></v-date-picker> </v-sheet
            ></template>
            <template v-slot:content-2>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-3"
                height="300"
              >
                <TimeWidget
                  @change="
                    (time, minute) => {
                      OneSeDateTime.StartTime = time;
                      OneSeDateTime.StartTimeMinute = minute;
                    }
                  "
                  :max="OneSeDateTime.Date ? SEDateTime.EndTimeMinute : ''"
                />
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="
                      border-color: var(--main-border-color);
                      margin-left: 7.5px;
                    "
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>
                <TimeWidget
                  isEnd
                  @change="
                    (time, minute) => {
                      OneSeDateTime.EndTime = time;
                      OneSeDateTime.EndTimeMinute = minute;
                    }
                  "
                  :min="OneSeDateTime.Date ? SEDateTime.StartTimeMinute : ''"
                />
              </v-sheet>
            </template>
          </Taber>
        </v-sheet>
        <v-sheet class="d-flex pa-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize mx-6"
            @click="onCancel"
            small
            rounded
            >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            :disabled="
              !canConfirm ||
              !OneSeDateTime.Date ||
              !OneSeDateTime.StartTime ||
              !OneSeDateTime.EndTime
            "
            small
            @click="
              $refs.menu.save(
                OneSeDateTime.Date +
                  ',' +
                  OneSeDateTime.StartTime +
                  ' - ' +
                  OneSeDateTime.EndTime
              )
            "
            >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
          >
        </v-sheet>
      </v-card-text></v-card
    >
    <v-card v-if="type == 'datetimerange'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet
          class="d-flex flex-row justify-space-arounnd pa-3"
          height="400"
        >
          <Taber
            :curTab="curTab"
            :items="taber"
            @change="(tab) => (curTab = tab)"
            backgroundColor="white"
            :grow="false"
            special
            :centered="false"
          >
            <template v-slot:content-1>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-0"
                height="260"
              >
                <v-date-picker
                  :day-format="
                    (date) => {
                      return $getDateTime(date, 'D');
                    }
                  "
                  :locale="defaultLang"
                  v-model="SEDateTime.StartDate"
                  no-title
                  :show-current="false"
                  scrollable
                  color="primary"
                  flat
                  :max="SEDateTime.EndDate"
                ></v-date-picker>
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="
                      border-color: var(--main-border-color);
                      margin-left: 7.5px;
                    "
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>
                <v-date-picker
                  :day-format="
                    (date) => {
                      return $getDateTime(date, 'D');
                    }
                  "
                  :locale="defaultLang"
                  v-model="SEDateTime.EndDate"
                  no-title
                  :show-current="false"
                  scrollable
                  color="primary"
                  flat
                  :min="SEDateTime.StartDate"
                ></v-date-picker>
              </v-sheet>
            </template>
            <template v-slot:content-2>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-3"
                height="320"
              >
                <TimeWidget
                  @change="
                    (time, minute) => {
                      SEDateTime.StartTime = time;
                      SEDateTime.StartTimeMinute = minute;
                    }
                  "
                  :max="
                    SEDateTime.StartDate
                      ? SEDateTime.EndDate
                        ? SEDateTime.StartDate == SEDateTime.EndDate
                          ? SEDateTime.EndTimeMinute
                          : ''
                        : SEDateTime.EndTimeMinute
                      : SEDateTime.EndTimeMinute
                  "
                />
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="
                      border-color: var(--main-border-color);
                      margin-left: 7.5px;
                    "
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>
                <TimeWidget
                  isEnd
                  @change="
                    (time, minute) => {
                      SEDateTime.EndTime = time;
                      SEDateTime.EndTimeMinute = minute;
                    }
                  "
                  :min="
                    SEDateTime.StartDate
                      ? SEDateTime.EndDate
                        ? SEDateTime.StartDate == SEDateTime.EndDate
                          ? SEDateTime.StartTimeMinute
                          : ''
                        : SEDateTime.StartTimeMinute
                      : SEDateTime.StartTimeMinute
                  "
                />
              </v-sheet>
            </template>
          </Taber>
        </v-sheet>
        <v-sheet class="d-flex pa-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize mx-6"
            @click="onCancel"
            small
            rounded
            >{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            :disabled="
              !canConfirm || !SEDateTime.StartDate || !SEDateTime.EndDate
            "
            small
            @click="
              $refs.menu.save(
                SEDateTime.StartDate +
                  ' ' +
                  SEDateTime.StartTime +
                  ' - ' +
                  SEDateTime.EndDate +
                  ' ' +
                  SEDateTime.EndTime
              )
            "
            >{{ $t("label_essweb_form_tools_oKBtnLabel") }}</v-btn
          >
        </v-sheet>
      </v-card-text>
    </v-card>
  </v-menu>
</template>
<script>
import TimeWidget from "@/components/TimeWidget";
import TimeWidgetSE from "@/components/TimeWidget_SE";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  name: "NewDateTimePicker",
  components: { TimeWidget, TimeWidgetSE },
  props: {
    placeholder: { default: "", type: String },
    max: { default: "", type: String },
    min: { default: "", type: String },
    url_type: { default: "client", type: String },
    rules: {
      default: function () {
        return [];
      },
      type: Array,
    },
    disabled: { default: false, type: Boolean },
    filled: { default: true, type: Boolean },
    defaultTime: { default: "", type: String },
    hideDetail: { default: false, type: Boolean },
    defaultStartTime: { default: "", type: String },
    defaultEndTime: { default: "", type: String },
    label: { default: "", type: String },
    staff_uuid: { default: "", type: [String, Number] },
    refuseDate: {
      default: function () {
        return [];
      },
      type: Array,
    },
    leaveTransactionTypeCode: { default: "", type: [String, Number] },
    isAllowDate: { default: false, type: Boolean },
    TimeType: { default: 60, type: [String, Number] },
    type: {
      default: "",
      type: String,
      required: true,
      validator: function (value) {
        return (
          [
            "date",
            "time",
            "month",
            "year",
            "datetime",
            "daterange",
            "timerange",
            "daytime",
            "day15min",
            "day30min",
            "datetimerange",
            "onedatetimerange",
            "dateapm",
          ].indexOf(value) !== -1
        );
      },
    },
  },
  computed: {
    ...mapGetters(["defaultLang"]),
    isRequire() {
      return this.rules ? (this.rules.length ? true : false) : false;
    },
  },
  data() {
    let key = Math.random() * 1000;
    return {
      leaveInfo: null,
      showMenu: false,
      curKey: key,
      datetime: "",
      startMinTime: 0,
      endMaxTime: 1440,
      curTab: "tab-1",
      taber: [
        "label_essweb_system_timeWidget_tag_dateLabel",
        "label_essweb_system_timeWidget_tag_timeLabel",
      ],
      dayTime: {
        StartDate: "",
        EndDate: "",
        defaultHour_forEnd: "",
        defaultHour: "",
        defaultMin_forEnd: "",
        defaultMin: "",
        StartTime: "00:00",
        StartTimeMinute: 0,
        EndTime: "00:00",
        EndTimeMinute: 0,
        startMinTime_forEnd: 0,
        endMaxTime_forEnd: 1440,
      },
      day15Minute: {
        StartDate: "",
        EndDate: "",
        defaultHour: "",
        defaultHour_forEnd: "",
        defaultMin: "",
        defaultMin_forEnd: "",
        defaultMax: "",
        StartTime: "00:00",
        StartTimeMinute: 0,
        EndTime: "00:00",
        EndTimeMinute: 0,
        startMinTime_forEnd: 0,
        endMaxTime_forEnd: 1440,
      },
      day30Minute: {
        StartDate: "",
        EndDate: "",
        defaultHour: "",
        defaultHour_forEnd: "",
        defaultMax: "",
        defaultMin: "",
        defaultMin_forEnd: "",
        StartTime: "00:00",
        StartTimeMinute: 0,
        EndTime: "00:00",
        EndTimeMinute: 0,
        startMinTime_forEnd: 0,
        endMaxTime_forEnd: 1440,
      },
      SEDateTime: {
        StartDate: "",
        EndDate: "",
        StartTime: "00:00",
        StartTimeMinute: 0,
        EndTime: "00:00",
        EndTimeMinute: 0,
      },
      OneSeDateTime: {
        Date: "",
        StartDate: "",
        EndDate: "",
        StartTime: "00:00",
        StartTimeMinute: 0,
        EndTime: "00:00",
        EndTimeMinute: 0,
      },
      DateAPM: {
        StartDate: "",
        EndDate: "",
        start: "AM",
        end: "AM",
        StartTime: "00:00",
        StartTimeMinute: 12 * 60,
        EndTime: "24:00",
        EndTimeMinute: 12 * 60,
      },
      SEDate: { StartDate: "", EndDate: "" },
      DateTime: { Date: "", Time: "00:00" },
      TimeRange: {
        StartTime: "",
        StartTimeMinute: 0,
        EndTime: "",
        EndTimeMinute: 0,
      },
      canConfirm: false,
      defaultMin: null,
      defaultMax: null,
    };
  },
  created() {
    this.curTab = "tab-2";
    this.$Sleep(1000).then((e) => {
      this.curTab = "tab-1";
    });
  },
  watch: {
    curTab(val) {
      if (val == "tab-2") {
        this.canConfirm = true;
      }
    },
    showMenu(val) {
      this.$Sleep(500).then(() => {
        //解决tab栏底线不适应
        var e = new Event("resize");
        window.dispatchEvent(e);
      });
      if (!val) this.curTab = "";
      else this.curTab = "tab-1";
    },
    time(val) {
      this.DateTime.Time = val;
    },
    datetime(val) {
      if (val == "") {
        this.onClear();
      }
      this.$emit("change", val, this.type);
    },
    defaultStartTime(val) {
      if (val)
        if (this.type == "datetimerange") {
          // 暂时只处理datetimerange
          this.SEDateTime.StartDate = val ? val.split(" ")[0] : "";
          this.SEDateTime.StartTime = val ? val.split(" ")[1] : "";
          this.SEDateTime.StartTimeMinute = this.$timeMachine(
            this.SEDateTime.StartTime
          );
          // this.datetime =
          //   this.SEDateTime.StartDate +
          //   " " +
          //   this.SEDateTime.StartTime +
          //   " - " +
          //   this.SEDateTime.EndDate +
          //   " " +
          //   this.SEDateTime.EndTime;
          this.$refs.menu.save(
            this.SEDateTime.StartDate +
              " " +
              this.SEDateTime.StartTime +
              " - " +
              this.SEDateTime.EndDate +
              " " +
              this.SEDateTime.EndTime
          );
        }
    },
    defaultEndTime(val) {
      if (val)
        if (this.type == "datetimerange") {
          // 暂时只处理datetimerange
          this.SEDateTime.EndDate = val ? val.split(" ")[0] : "";
          this.SEDateTime.EndTime = val ? val.split(" ")[1] : "";
          this.SEDateTime.EndTimeMinute = this.$timeMachine(
            this.SEDateTime.EndTime
          );
          this.datetime =
            this.SEDateTime.StartDate +
            " " +
            this.SEDateTime.StartTime +
            " - " +
            this.SEDateTime.EndDate +
            " " +
            this.SEDateTime.EndTime;
          this.$refs.menu.save(
            this.SEDateTime.StartDate +
              " " +
              this.SEDateTime.StartTime +
              " - " +
              this.SEDateTime.EndDate +
              " " +
              this.SEDateTime.EndTime
          );
        }
    },
    defaultTime(val) {
      this.datetime = val;
      this.$refs.menu.save(val);
      this.showMenu = true;
    },
    leaveInfo(val) {
      if (val) {
        if (val["shifts"] && val["shifts"].length) {
          this.startMinTime = Number(val["shifts"][0]["start_utc_time"]);
          this.endMaxTime = Number(val["shifts"][0]["end_utc_time"]);
          if (this.type == "daytime") {
            let start = 0;
            this.dayTime.startMinTime_forEnd = this.startMinTime;
            this.dayTime.endMaxTime_forEnd = this.endMaxTime;
            if (this.startMinTime <= 0) {
              this.startMinTime = 0;
              this.dayTime.startMinTime_forEnd = this.startMinTime;
              start = 0;
            } else {
              if (this.startMinTime % 15 > 0) {
                start = parseInt(
                  (this.startMinTime - (this.startMinTime % 15)) / 60
                );
                this.dayTime.defaultHour = start >= 10 ? start : "0" + start;
                this.dayTime.defaultHour_forEnd =
                  start >= 10 ? start : "0" + start;
              } else {
                start = parseInt(this.startMinTime / 60);
                this.dayTime.defaultHour = start >= 10 ? start : "0" + start;
                this.dayTime.defaultHour_forEnd =
                  start >= 10 ? start : "0" + start;
              }
            }
            this.dayTime.defaultMin =
              (this.startMinTime - (this.startMinTime % 15)) % 60 >= 10
                ? (this.startMinTime - (this.startMinTime % 15)) % 60
                : "0" + ((this.startMinTime - (this.startMinTime % 15)) % 60);
            let tempMin = this.startMinTime % 60;
            let tempArr = [0, 15, 30, 45];
            const that = this;
            tempArr.forEach((item, index) => {
              if (tempMin >= item && tempMin < tempArr[index - 1]) {
                that.dayTime.defaultMin == item >= 10 ? item : "0" + item;
              } else {
                that.dayTime.defaultMin == tempArr[index + 1] >= 10
                  ? tempArr[index + 1]
                  : "0" + tempArr[index + 1];
              }
            });
            this.dayTime.defaultMin_forEnd = this.dayTime.defaultMin;
          }
          if (this.type == "day15min") {
            let start = 0;
            this.day15Minute.startMinTime_forEnd = this.startMinTime;
            this.day15Minute.endMaxTime_forEnd = this.endMaxTime;
            if (this.startMinTime <= 0) {
              this.startMinTime = 0;
              this.day15Minute.startMinTime_forEnd = this.startMinTime;
              start = 0;
            } else {
              if (this.startMinTime % Number(this.TimeType) > 0) {
                start = parseInt(
                  (this.startMinTime -
                    (this.startMinTime % Number(this.TimeType))) /
                    60
                );
                this.day15Minute.defaultHour =
                  start >= 10 ? start : "0" + start;
                this.day15Minute.defaultHour_forEnd =
                  start >= 10 ? start : "0" + start;
              } else {
                start = parseInt(this.startMinTime / 60);
                this.day15Minute.defaultHour =
                  start >= 10 ? start : "0" + start;
                this.day15Minute.defaultHour_forEnd =
                  start >= 10 ? start : "0" + start;
              }
            }

            this.day15Minute.defaultMin =
              (this.startMinTime -
                (this.startMinTime % Number(this.TimeType))) %
                60 >=
              10
                ? (this.startMinTime -
                    (this.startMinTime % Number(this.TimeType))) %
                  60
                : "0" +
                  ((this.startMinTime -
                    (this.startMinTime % Number(this.TimeType))) %
                    60);
            let tempMin = this.startMinTime % 60;
            let tempArr = [0, 15, 30, 45];
            const that = this;
            tempArr.forEach((item, index) => {
              if (tempMin >= item && tempMin < tempArr[index - 1]) {
                that.day15Minute.defaultMin == item >= 10 ? item : "0" + item;
              } else {
                that.day15Minute.defaultMin == tempArr[index + 1] >= 10
                  ? tempArr[index + 1]
                  : "0" + tempArr[index + 1];
              }
            });
            this.day15Minute.defaultMin_forEnd = this.day15Minute.defaultMin;
          }
          if (this.type == "day30min") {
            let start = 0;
            this.day30Minute.startMinTime_forEnd = this.startMinTime;
            this.day30Minute.endMaxTime_forEnd = this.endMaxTime;
            if (this.startMinTime <= 0) {
              this.startMinTime = 0;
              this.day30Minute.startMinTime_forEnd = this.startMinTime;
              start = 0;
            } else {
              if (this.startMinTime % Number(this.TimeType) > 0) {
                start = parseInt(
                  (this.startMinTime -
                    (this.startMinTime % Number(this.TimeType))) /
                    60
                );
                this.day30Minute.defaultHour =
                  start >= 10 ? start : "0" + start;
                this.day30Minute.defaultHour_forEnd =
                  start >= 10 ? start : "0" + start;
              } else {
                start = parseInt(this.startMinTime / 60);
                this.day30Minute.defaultHour =
                  start >= 10 ? start : "0" + start;
                this.day30Minute.defaultHour_forEnd =
                  start >= 10 ? start : "0" + start;
              }
            }

            this.day30Minute.defaultMin =
              (this.startMinTime -
                (this.startMinTime % Number(this.TimeType))) %
                60 >=
              10
                ? (this.startMinTime -
                    (this.startMinTime % Number(this.TimeType))) %
                  60
                : "0" +
                  ((this.startMinTime -
                    (this.startMinTime % Number(this.TimeType))) %
                    60);
            let tempMin = this.startMinTime % 60;
            let tempMax = this.endMaxTime % 60;
            let tempArr = [0, 30];
            const that = this;
            tempArr.forEach((item, index) => {
              if (tempMin >= item && tempMin < tempArr[index - 1]) {
                that.day30Minute.defaultMin == item >= 10 ? item : "0" + item;
              } else {
                that.day30Minute.defaultMin == tempArr[index + 1] >= 10
                  ? tempArr[index + 1]
                  : "0" + tempArr[index + 1];
              }
              // if(tempMax>=item && tempMax < tempArr[index - 1]){
              //   that.day30Minute.defaultMax == tempArr[index - 1] >= 10 ? tempArr[index - 1] : "0" + item;
              // }
            });
            this.day30Minute.defaultMin_forEnd = this.day30Minute.defaultMin;
          }
        }
      }
    },
    "day15Minute.StartDate": function (date) {
      if (date) {
        this.day15Minute.EndDate = "";
        this.day15Minute.defaultHour = "";
        this.day15Minute.defaultHour_forEnd = "";
        this.day15Minute.defaultMin = "";
        this.day15Minute.defaultMin_forEnd = "";
        this.day15Minute.StartTime = "00:00";
        this.day15Minute.StartTimeMinute = 0;
        this.day15Minute.EndTime = "00:00";
        this.day15Minute.EndTimeMinute = 0;
        this.getMyShiftTime(date, this.staff_uuid);
      }
    },
    "day15Minute.EndDate": function (date) {
      if (date) {
        if (
          date != this.day15Minute.StartDate &&
          this.day15Minute.StartDate != ""
        ) {
          //不限制输入结束时间
          this.day15Minute.startMinTime_forEnd = 0;
          this.day15Minute.endMaxTime_forEnd = 1440;
        }
        if (date == this.day15Minute.StartDate) {
          this.day15Minute.EndDate = date;
          this.day15Minute.defaultHour = "";
          this.day15Minute.defaultHour_forEnd = "";
          this.day15Minute.defaultMin = "";
          this.day15Minute.defaultMin_forEnd = "";
          this.day15Minute.StartTime = "00:00";
          this.day15Minute.StartTimeMinute = 0;
          this.day15Minute.EndTime = "00:00";
          this.day15Minute.EndTimeMinute = 0;
          this.getMyShiftTime(date, this.staff_uuid);
        }
      }
    },
    "day15Minute.StartTimeMinute": function (time) {
      let min = Number(time) % 60;
      this.day15Minute.EndTimeMinute =
        Number(this.day15Minute.EndTimeMinute) -
        (Number(this.day15Minute.EndTimeMinute) % 60) +
        min;
      this.day15Minute.defaultHour =
        parseInt(time / 60) >= 10
          ? parseInt(time / 60)
          : "0" + parseInt(time / 60);
      this.day15Minute.defaultMin =
        parseInt(time % 60) >= 10
          ? parseInt(time % 60)
          : "0" + parseInt(time % 60);
    },
    "day15Minute.EndTimeMinute": function (time) {
      let min = Number(time) % 60;
      // this.day15Minute.StartTimeMinute =
      //   Number(this.day15Minute.StartTimeMinute) -
      //   (Number(this.day15Minute.StartTimeMinute) % 60) +
      //   min;
      this.day15Minute.defaultHour_forEnd =
        parseInt(time / 60) >= 10
          ? parseInt(time / 60)
          : "0" + parseInt(time / 60);
      this.day15Minute.defaultMin_forEnd =
        parseInt(time % 60) >= 10
          ? parseInt(time % 60)
          : "0" + parseInt(time % 60);
    },
    "dayTime.StartDate": function (date) {
      if (date) {
        this.dayTime.EndDate = "";
        this.dayTime.defaultHour = "";
        this.dayTime.defaultHour_forEnd = "";
        this.dayTime.defaultMin = "";
        this.dayTime.defaultMin_forEnd = "";
        this.dayTime.StartTime = "00:00";
        this.dayTime.StartTimeMinute = 0;
        this.dayTime.EndTime = "00:00";
        this.dayTime.EndTimeMinute = 0;
        this.getMyShiftTime(date, this.staff_uuid);
      }
    },

    "dayTime.EndDate": function (date) {
      if (date) {
        if (date != this.dayTime.StartDate && this.dayTime.StartDate != "") {
          //不限制输入结束时间
          this.dayTime.startMinTime_forEnd = 0;
          this.dayTime.endMaxTime_forEnd = 1440;
        }
        if (date == this.dayTime.StartDate) {
          this.dayTime.EndDate = date;
          this.dayTime.defaultHour = "";
          this.dayTime.defaultHour_forEnd = "";
          this.dayTime.defaultMin = "";
          this.dayTime.defaultMin_forEnd = "";
          this.dayTime.StartTime = "00:00";
          this.dayTime.StartTimeMinute = 0;
          this.dayTime.EndTime = "00:00";
          this.dayTime.EndTimeMinute = 0;
          this.getMyShiftTime(date, this.staff_uuid);
        }
      }
    },
    "dayTime.StartTimeMinute": function (time) {
      let min = Number(time) % 60;
      this.dayTime.EndTimeMinute =
        Number(this.dayTime.EndTimeMinute) -
        (Number(this.dayTime.EndTimeMinute) % 60) +
        min;
      this.dayTime.defaultHour =
        parseInt(time / 60) >= 10
          ? parseInt(time / 60)
          : "0" + parseInt(time / 60);
      this.dayTime.defaultMin =
        parseInt(time % 60) >= 10
          ? parseInt(time % 60)
          : "0" + parseInt(time % 60);
    },
    "dayTime.EndTimeMinute": function (time) {
      let min = Number(time) % 60;
      this.dayTime.StartTimeMinute =
        Number(this.dayTime.StartTimeMinute) -
        (Number(this.dayTime.StartTimeMinute) % 60) +
        min;
      this.dayTime.defaultHour_forEnd =
        parseInt(time / 60) >= 10
          ? parseInt(time / 60)
          : "0" + parseInt(time / 60);
      this.dayTime.defaultMin_forEnd =
        parseInt(time % 60) >= 10
          ? parseInt(time % 60)
          : "0" + parseInt(time % 60);
    },
    "day30Minute.StartDate": function (date) {
      if (date) {
        this.day30Minute.EndDate = "";
        this.day30Minute.defaultHour = "";
        this.day30Minute.defaultHour_forEnd = "";
        this.day30Minute.defaultMin = "";
        this.day30Minute.defaultMin_forEnd = "";
        this.day30Minute.StartTime = "00:00";
        this.day30Minute.StartTimeMinute = 0;
        this.day30Minute.EndTime = "00:00";
        this.day30Minute.EndTimeMinute = 0;
        this.getMyShiftTime(date, this.staff_uuid);
      }
    },
    "day30Minute.EndDate": function (date) {
      if (date) {
        if (
          date != this.day30Minute.StartDate &&
          this.day30Minute.StartDate != ""
        ) {
          //不限制输入结束时间
          this.day30Minute.startMinTime_forEnd = 0;
          this.day30Minute.endMaxTime_forEnd = 1440;
        }
        if (date == this.day30Minute.StartDate) {
          this.day30Minute.EndDate = date;
          this.day30Minute.defaultHour = "";
          this.day30Minute.defaultHour_forEnd = "";
          this.day30Minute.defaultMin = "";
          this.day30Minute.defaultMin_forEnd = "";
          this.day30Minute.StartTime = "00:00";
          this.day30Minute.StartTimeMinute = 0;
          this.day30Minute.EndTime = "00:00";
          this.day30Minute.EndTimeMinute = 0;
          this.getMyShiftTime(date, this.staff_uuid);
        }
      }
    },
    "day30Minute.StartTimeMinute": function (time) {
      let min = Number(time) % 60;
      this.day30Minute.EndTimeMinute =
        Number(this.day30Minute.EndTimeMinute) -
        (Number(this.day30Minute.EndTimeMinute) % 60) +
        min;
      this.day30Minute.defaultHour =
        parseInt(time / 60) >= 10
          ? parseInt(time / 60)
          : "0" + parseInt(time / 60);
      this.day30Minute.defaultMin =
        parseInt(time % 60) >= 10
          ? parseInt(time % 60)
          : "0" + parseInt(time % 60);
    },
    "day30Minute.EndTimeMinute": function (time) {
      let min = Number(time) % 60;
      // this.day30Minute.StartTimeMinute =
      //   Number(this.day30Minute.StartTimeMinute) -
      //   (Number(this.day30Minute.StartTimeMinute) % 60) +
      //   min;
      this.day30Minute.defaultHour_forEnd =
        parseInt(time / 60) >= 10
          ? parseInt(time / 60)
          : "0" + parseInt(time / 60);
      this.day30Minute.defaultMin_forEnd =
        parseInt(time % 60) >= 10
          ? parseInt(time % 60)
          : "0" + parseInt(time % 60);
    },
  },
  mounted() {
    const that = this;

    this.datetime = this.defaultTime;
    this.$refs.menu.save(this.defaultTime);
    if (this.defaultTime && this.type == "daterange") {
      this.SEDate = {
        StartDate: this.defaultTime ? this.defaultTime.split(" - ")[0] : "",
        EndDate: this.defaultTime ? this.defaultTime.split(" - ")[1] : "",
        StartTime: "00:00",
        StartTimeMinute: 0,
        EndTime: "00:00",
        EndTimeMinute: 0,
      };
      if (this.isAllowDate) {
        //限制範圍
        this.defaultMin = this.defaultTime
          ? this.defaultTime.split(" - ")[0]
          : "";
        this.defaultMax = this.defaultTime
          ? this.defaultTime.split(" - ")[1]
          : "";
      }
    }
  },
  methods: {
    onClear(type) {
      this.datetime = "";
      this.curTab = "tab-1";
      this.startMinTime = 0;
      this.endMaxTime = 1440;
      this.dayTime = {
        StartDate: "",
        EndDate: "",
        defaultHour: "",
        defaultHour_forEnd: "",
        defaultMin: "",
        defaultMin_forEnd: "",
        defaultMax: "",
        StartTime: "00:00",
        StartTimeMinute: 0,
        EndTime: "00:00",
        EndTimeMinute: 0,
        startMinTime_forEnd: 0,
        endMaxTime_forEnd: 1440,
      };
      this.day15Minute = {
        StartDate: "",
        EndDate: "",
        defaultHour: "",
        defaultHour_forEnd: "",
        defaultMin: "",
        defaultMin_forEnd: "",
        defaultMax: "",
        StartTime: "00:00",
        StartTimeMinute: 0,
        EndTime: "00:00",
        EndTimeMinute: 0,
        startMinTime_forEnd: 0,
        endMaxTime_forEnd: 1440,
      };
      this.day30Minute = {
        StartDate: "",
        EndDate: "",
        defaultHour: "",
        defaultHour_forEnd: "",
        defaultMin: "",
        defaultMin_forEnd: "",
        defaultMax: "",
        StartTime: "00:00",
        StartTimeMinute: 0,
        EndTime: "00:00",
        EndTimeMinute: 0,
        startMinTime_forEnd: 0,
        endMaxTime_forEnd: 1440,
      };
      this.SEDateTime = {
        StartDate: "",
        EndDate: "",
        StartTime: "00:00",
        StartTimeMinute: 0,
        EndTime: "00:00",
        EndTimeMinute: 0,
      };
      this.OneSeDateTime = {
        Date: "",
        StartDate: "",
        EndDate: "",
        StartTime: "00:00",
        StartTimeMinute: 0,
        EndTime: "00:00",
        EndTimeMinute: 0,
      };
      this.DateAPM = {
        StartDate: "",
        EndDate: "",
        start: "AM",
        end: "AM",
        StartTime: "00:00",
        StartTimeMinute: 12 * 60,
        EndTime: "24:00",
        EndTimeMinute: 12 * 60,
      };
      this.SEDate = { StartDate: "", EndDate: "" };
      this.DateTime = { Date: "", Time: "00:00" };
      this.TimeRange = {
        StartTime: "",
        StartTimeMinute: 0,
        EndTime: "",
        EndTimeMinute: 0,
      };
    },
    getTimeValue: function (datetime) {
      if (!str) return "";
      let str = datetime.replace(/\-/g, "/");
      if (str.indexOf(" / ") != -1) str.replace(" / ", " - ");
      return str;
    },
    getMyShiftTime: function (date, staff) {
      const that = this;
      that.leaveInfo = null;
      //赚取类型，不限制输入时间
      if (this.leaveTransactionTypeCode == "EARN") return;
      this.$Request({
        method: "POST",
        table: "ess_punch_records_master",
        url: "/leave/get-leave-day-details/",
        data: {
          applicant_staff_uuid: staff, //2020-03-02 applition_staff_id-->applicant_staff_uuid BJ
          start_utc_datetime: this.$getTimeValue(date + " 00:00:00"),
        },
        type: this.url_type,
      }).then((res) => {
        that.leaveInfo = res.data;
      });
    },
    onCancel: function () {
      this.SEDate = {
        StartDate: this.$refs.menu.returnValue
          ? this.$refs.menu.returnValue.split(" - ")[0]
          : "",
        EndDate: this.$refs.menu.returnValue
          ? this.$refs.menu.returnValue.split(" - ")[1]
          : "",
      };
      this.datetime = this.$refs.menu.returnValue;
      this.showMenu = false;
    },
    getMaxMin: function (type) {
      if (type == "maxdate") {
        if (!this.max) {
          return "";
        } else {
          return dayjs(this.max).format("YYYY-MM-DD");
        }
      }
      if (type == "mindate") {
        if (!this.min) {
          return "";
        } else {
          return dayjs(this.min).format("YYYY-MM-DD");
        }
      }
      if (type == "mintime") {
        if (
          dayjs(this.min).format("YYYY-MM-DD") !=
          dayjs(this.max).format("YYYY-MM-DD")
        ) {
          return "";
        } else {
          if (!this.min) {
            return "";
          } else {
            return this.$timeMachine(dayjs(this.min).format("HH:mm"));
          }
        }
      }
      if (type == "maxtime") {
        if (
          dayjs(this.min).format("YYYY-MM-DD") !=
          dayjs(this.max).format("YYYY-MM-DD")
        ) {
          return "";
        } else {
          if (!this.min) {
            return "";
          } else {
            return this.$timeMachine(dayjs(this.min).format("HH:mm"));
          }
        }
      }
    },
    timeMachine: function (day, hour, minute) {
      return Number(day) * 60 * 24 + Number(hour) * 60 + Number(minute);
    },
  },
};
</script>
<style scoped>
.border_style {
  width: 8px;
  height: 8px;
  position: absolute;
  margin-left: 5px;
  border-top: 1px solid var(--main-border-color);
  border-right: 1px solid var(--main-border-color);
  background: white;
  transform: rotate(45deg);
}
</style>
